<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-header">
          <div class="page-title">{{ $t('message.home.allStores') }}</div>
          <el-input v-model="keyword" :placeholder="$t('message.home.searchStore')" prefix-icon="el-icon-search"
            style="width:280px" @keyup.enter.native="handleSearch" clearable @clear="handleSearch" />
        </div>

        <div v-loading="loading">
          <div class="store-grid" v-if="list.length">
            <div class="store-card" v-for="item in list" :key="item.id" @click="goStore(item)">
              <img :src="item.storeLogo || require('@/assets/image/01.png')" class="store-logo" alt="" />
              <div class="store-name">{{ item.storeName }}</div>
              <div class="store-desc">{{ item.storeIntroduction }}</div>
              <el-button size="mini" type="primary" plain>{{ $t('message.home.viewStore') }}</el-button>
            </div>
          </div>
          <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
          <div class="common-pagination" v-if="total > 0">
            <el-pagination background layout="prev,pager,next,total" :page-size="queryParams.pageSize"
              :current-page="queryParams.pageNumber" :total="total" @current-change="currentChange" />
          </div>
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import request from "@/util/http";

export default {
  name: "StoreList",
  data() {
    return { loading: false, list: [], total: 0, keyword: '',
      queryParams: { pageNumber: 1, pageSize: 20 } }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      request({ url: '/store/biz/store/list', method: 'get', params: { ...this.queryParams, storeName: this.keyword || null } }).then(r => {
        this.list = r.data?.data?.content || []
        this.total = r.data?.data?.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleSearch() { this.queryParams.pageNumber = 1; this.loadData() },
    currentChange(page) { this.queryParams.pageNumber = page; this.loadData() },
    goStore(item) { this.$router.push('/store/' + item.id) }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 24px; }
.page-title { font-size: 22px; font-weight: bold; }
.store-grid { display: flex; flex-wrap: wrap; gap: 16px; }
.store-card { background: #fff; border-radius: 8px; width: 220px; padding: 20px; text-align: center; cursor: pointer; transition: box-shadow .2s; }
.store-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,.1); }
.store-logo { width: 80px; height: 80px; border-radius: 50%; object-fit: cover; margin-bottom: 10px; }
.store-name { font-size: 15px; font-weight: bold; color: #303133; margin-bottom: 6px; }
.store-desc { font-size: 13px; color: #909399; margin-bottom: 12px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; min-height: 36px; }
.common-pagination { margin-top: 24px; text-align: center; }
</style>
